import React, { useEffect, useState } from 'react';
import { fetchCatalogProductDetails, CatalogProductDetails } from './services/catalogAPI';
import styles from './AwsProductDetailModal.module.css';

interface AwsProductDetailModalProps {
    productRef: string;
    onClose: () => void;
}

const AwsProductDetailModal: React.FC<AwsProductDetailModalProps> = ({ productRef, onClose }) => {
    const [details, setDetails] = useState<CatalogProductDetails | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchDetails = async () => {
            setIsLoading(true);
            try {
                const data = await fetchCatalogProductDetails(productRef);
                setDetails(data);
            } catch (err) {
                console.error('Erro ao carregar detalhes do produto:', err);
                setError('Não foi possível carregar os detalhes do produto.');
            } finally {
                setIsLoading(false);
            }
        };

        if (productRef) {
            fetchDetails();
        }
    }, [productRef]);

    if (isLoading) {
        return (
            <div className={styles.modalOverlay} onClick={onClose}>
                <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
                    <div className={styles.loading}>Carregando detalhes...</div>
                </div>
            </div>
        );
    }

    if (error || !details) {
        return (
            <div className={styles.modalOverlay} onClick={onClose}>
                <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
                    <div className={styles.error}>{error || 'Produto não encontrado.'}</div>
                    <button className={styles.closeBtn} onClick={onClose}>Fechar</button>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
                <button className={styles.closeBtnTop} onClick={onClose}>&times;</button>

                <div className={styles.modalBody}>
                    <div className={styles.imageSection}>
                        {details.img ? (
                            <img src={details.img} alt={details.DESCRICAO} className={styles.productImage} />
                        ) : (
                            <div className={styles.noImage}>Sem imagem disponível</div>
                        )}
                    </div>

                    <div className={styles.infoSection}>
                        <h2 className={styles.productTitle}>{details.DESCRICAO}</h2>
                        <div className={styles.refBadge}>REF: {details.REFERENCIA}</div>

                        <div className={styles.detailsGrid}>
                            <div className={styles.detailItem}>
                                <label>C.A</label>
                                <span>{details.CA || 'N/A'}</span>
                            </div>
                            <div className={styles.detailItem}>
                                <label>Grupo</label>
                                <span>{details.GRUPO2 || 'N/A'}</span>
                            </div>
                            <div className={styles.detailItem}>
                                <label>Família</label>
                                <span>{details.FAMILIA || 'N/A'}</span>
                            </div>
                            <div className={styles.detailItem}>
                                <label>Linha</label>
                                <span>{details.LINHA || 'N/A'}</span>
                            </div>
                            <div className={styles.detailItem}>
                                <label>Sub-Linha</label>
                                <span>{details.LINHA2 || 'N/A'}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AwsProductDetailModal;
